import { Controller } from "@hotwired/stimulus"
import { toggleElement, hideElement } from "../helpers/dom_helpers"

export default class extends Controller {
  static targets = ["menu"]

  connect() {
    document.addEventListener("click", this.#handleClickOutside)
  }

  disconnect() {
    document.removeEventListener("click", this.#handleClickOutside)
  }

  toggle() {
    toggleElement(this.menuTarget)
  }

  close() {
    hideElement(this.menuTarget)
  }

  #handleClickOutside = (event) => {
    if (!this.element.contains(event.target)) {
      this.close()
    }
  }
}
